import { render, staticRenderFns } from "./ShipperDenominatedRules.vue?vue&type=template&id=30ab3905&"
import script from "./ShipperDenominatedRules.vue?vue&type=script&lang=js&"
export * from "./ShipperDenominatedRules.vue?vue&type=script&lang=js&"
import style0 from "./ShipperDenominatedRules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports